<template>
  <!-- footer -->
  <div class="downFooter">
    <!-- 二维码 -->
    <div class="code">
      <img src="@/assets/pingxuan2022/pc/images/wechart-subscription.png" alt />
    </div>
    <div class="codeFont">
      <p>
        扫码关注
        <br />极果微信订阅号
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {},
  computed: {},
  mounted() {},
};
</script>

<style lang='scss' scoped>
.downFooter {
  width: 100%;
  height: 320px;
}
.downFooter .code {
  margin: 0 auto;
  padding-top: 45px; 
  width: 136px;
  height: 137px;
}
.code img {
  width: 100%;
  height: 100%;
}
.codeFont {
  margin: 0 auto;
  width: 127px;
  height: 44px;
  font-size: 18px;
  font-weight: 400;
  color: #FFFFFF;
  line-height: 27px;
  text-align: center;
  margin-top: 18px;
}
.downFooter .bgc {
  height: 50%;
}
</style>